var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgForwardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.36939 8.40184C2.51081 8.02955 2.86761 7.78342 3.26586 7.78342H7.88086L7.88086 5.14515C7.88191 4.97807 7.92782 4.81434 8.0138 4.67107C8.09977 4.5278 8.22265 4.41026 8.36959 4.33072C8.51653 4.25119 8.68213 4.21258 8.8491 4.21894C9.01606 4.22529 9.17825 4.27638 9.31872 4.36686C12.5055 5.74626 14.1704 6.75468 16.9367 8.96404C17.1988 9.17337 17.3867 9.44113 17.3867 9.76212C17.3867 10.0831 17.1611 10.3506 16.9367 10.5602C14.2756 13.0457 12.6023 14.0454 9.31871 15.1574C9.17685 15.2422 9.01498 15.2878 8.8497 15.2895C8.68441 15.2913 8.52163 15.249 8.37803 15.1672C8.23443 15.0853 8.11517 14.9667 8.03244 14.8236C7.94972 14.6805 7.90651 14.518 7.90724 14.3527L7.90724 11.7144H3.17922C2.84483 11.7144 2.54096 11.52 2.40083 11.2164C2.01469 10.3798 1.98148 9.42296 2.30871 8.56158L2.36939 8.40184Z",
    fill: "#84C70D",
    fillOpacity: 0.4,
    stroke: "#84C70D",
    strokeWidth: 1.45489,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForwardIcon);
export default __webpack_public_path__ + "static/media/forward-icon.4bb3a6904d23c02908e756c49488afdc.svg";
export { ForwardRef as ReactComponent };